<template>
  <div>
    <div class="text-weight-bold">Cliente</div>
    <q-select
      v-model="cliente"
      :options="listaClientes"
      @filter="filterFn"
      @input-value="setModel"
      use-input
      dense
      map-options
      outlined
      option-label="clienteId"
      option-value="clienteId"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum cliente encontrado
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, defineEmits, watch, defineProps } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["enviarCliente"]);
const props = defineProps(["model", "reset"]);
const time = ref();
const store = useStore();

const cliente = ref(props.model);
const listaClientes = ref([]);

const listarClientes = async (val) => {
  try {
    const response = await store.dispatch("office/listarCliente");
    listaClientes.value = response.listaClientes.filter((cliente) => {
      return cliente.clienteId.toLowerCase().includes(val.toLowerCase());
    });
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => cliente.value,
  () => {
    if (cliente.value != "") {
      emit("enviarCliente", cliente.value);
    }
  }
);

watch(
  () => props.model,
  () => {
    cliente.value = props.model;
  }
);

watch(
  () => props.reset,
  () => {
    cliente.value = "";
  }
);

function filterFn(val, update) {
  clearTimeout(time.value);

  time.value = setTimeout(() => {
    listarClientes(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
}

function setModel(val) {
  if (val === "") {
    cliente.value = val;
  }
}
</script>
